import useBuildVariantProps from "../../../../modules/theme/useBuildVariantProps";
import { ListItemType, RootListProps } from "../List.types";
import cx from 'classnames';
import styles from '../List.module.scss';

/**
 * A root list component that provides layout and styling for list items.
 * 
 * @template T - The type of the list items.
 * @param {RootListProps<T>} props - The properties for the root list.
 * @returns {JSX.Element} The rendered root list.
 */
export const RootList = <T extends ListItemType>(props: RootListProps<T>) => {
  const {
    align = 'Horizontal',
    wrap,
    className,
    children,
    ...restProps
  } = props;

  const variantProps = useBuildVariantProps(
    'list',
    { align },
  );

  return (
    <ul
      {...restProps}
      className={cx(styles.list,
        {
          [styles.wrap]: wrap,
        },
        className,
      )}
      {...variantProps}
    >
      {children}
    </ul>
  )
}